// eslint-disable-next-line import/no-cycle
import { getUserWixId } from 'modules/user/utils';
import userConstants from '../constants';
import { adjustConditionProfile, adjustMissingCriticalInfo } from '../functions';

const getInitialData = () => ({
  info: {
    user_wix_id: null,
    country: null,
    email: null,
    family_name: null,
    phone: null,
    partner: null,
    user_type: null,
  },
  personal: {
    user_wix_id: null,
    profile_id: null,
    patient_id: null,
    condition: null,
    gender: null,
    dob: null,
    travel_limit: null,
    looking_for: null,
  },
  condition_profile: {},
  missing_critical_info: {},
  trialsCount: null,
});

const getInitialState = () => ({
  originalData: null,
  data: getInitialData(),
});

function profileData(state, action) {
  switch (action.type) {
    case userConstants.SET_CONDITION:
      return {
        ...state,
        personal: {
          ...state.personal,
          condition: action.payload.condition, // for some conditions it is adjusted to general for e.g.
          conditionSubType: action.payload.conditionSubType,
        },
      };
    case userConstants.SET_USER_DATA:
      return {
        ...state,
        ...action.payload,
        info: {
          ...state.info,
          ...action.payload.info,
        },
        personal: {
          ...state.personal,
          ...action.payload.personal,
        },
        condition_profile: {
          ...state.condition_profile,
          ...(action.payload.condition_profile ? adjustConditionProfile(action.payload.condition_profile) : {}),
        },
        missing_critical_info: action.payload.missing_critical_info
          ? adjustMissingCriticalInfo(action.payload.missing_critical_info)
          : {},
      };
    case userConstants.SET_USER_WIX_ID:
      return {
        ...state,
        info: {
          ...state.info,
          user_wix_id: action.payload,
        },
        personal: {
          ...state.personal,
          user_wix_id: action.payload,
        },
      };
    case userConstants.SET_PROFILE_ID:
      return {
        ...state,
        personal: {
          ...state.personal,
          profile_id: action.payload,
        },
      };
    case userConstants.SET_TRIALS_COUNT:
      return {
        ...state,
        trialsCount: action.payload,
      };
    case userConstants.SET_PATIENT_ID:
      return {
        ...state,
        personal: {
          ...state.personal,
          patient_id: action.payload,
        },
      };
    case userConstants.SET_NEW_PROFILE:
      return {
        info: {
          user_wix_id: action.payload.user_wix_id,
          country: null,
          email: action.payload.email,
          family_name: action.payload.family_name,
          phone: action.payload.phone,
          partner: null,
          user_type: null,
        },
        personal: {
          user_wix_id: action.payload.user_wix_id,
          profile_id: null,
          patient_id: null,
          condition: null,
          gender: null,
          dob: null,
          travel_limit: null,
          looking_for: null,
          ...action.payload.personal,
        },
        condition_profile: {},
        missing_critical_info: {},
        // ? trialsCount is preserved
      };
    case userConstants.UPSERT_USER_PATIENT: {
      const { payload: nextPatient } = action;
      const userWixId = getUserWixId(nextPatient);
      const patientIndex = (state.patients ?? []).findIndex((patientItem) => getUserWixId(patientItem) === userWixId);
      const nextPatients = [...(state.patients ?? [])];
      if (patientIndex === -1) {
        nextPatients.push(nextPatient);
      } else {
        nextPatients[patientIndex] = nextPatient;
      }
      return {
        ...state,
        patients: nextPatients,
      };
    }

    default:
      return state;
  }
}

// eslint-disable-next-line default-param-last
export function profile(state = getInitialState(), action) {
  if (action === userConstants.LOGOUT) {
    return getInitialState();
  }

  const data = profileData(state.data, action);
  if (data !== state?.data) {
    const { meta: { source } = {} } = action;
    return {
      // some app part mutates data; data before mutation
      originalData: window.structuredClone(data),
      data,
      lastUpdateSource: source,
    };
  }
  return state;
}
